@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.PollingIndicator {
  display: flex;
  column-gap: 4px;
  align-items: center;
}
